export default "__VITE_ASSET__kJ5AuMdz__"